import { LOCALE_ID, NgModule, APP_INITIALIZER } from '@angular/core';
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { KeycloakAngularModule, KeycloakService } from '@mottu-ops/keycloak-angular';

registerLocaleData(localePt, 'pt');

function initializeKeycloak(keycloak: KeycloakService) {
	return () =>
		keycloak.init({
			config: {
				url: environment.keycloak.url,
				realm: environment.keycloak.realm,
				clientId: environment.keycloak.clientId,
			},
			initOptions: {
				onLoad: 'check-sso',
				silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
			},
			enableBearerInterceptor: false,
		});
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		AppRoutingModule,
		CoreModule,
		KeycloakAngularModule,
		ServiceWorkerModule.register('ngsw-worker.js', {
			enabled: environment.enableServiceWorker,
			registrationStrategy: 'registerWhenStable:30000',
		}),
	],
	providers: [
		{ provide: LOCALE_ID, useValue: 'pt' },
		{
			provide: APP_INITIALIZER,
			useFactory: initializeKeycloak,
			multi: true,
			deps: [KeycloakService],
		},
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
